import React from "react"
import { Skeleton } from "@material-ui/lab"
import { Grid, Typography } from "@material-ui/core"

import { Portlet } from "@/components"

type ActiveAttendancesSkeletonProps = {
	itemClassName?: string
}

const SKELETON_COUNT = 3

const ActiveAttendancesSkeleton: React.FC<ActiveAttendancesSkeletonProps> = ({ itemClassName }) => {
	return (
		<>
			{Array.from({ length: SKELETON_COUNT }, (_skeletonItem, skeletonIndex) => (
				<Portlet key={skeletonIndex} elevation={1} className={itemClassName}>
					<Grid container alignItems="center" spacing={2} wrap="nowrap">
						<Grid item>
							<Skeleton variant="circle" width={40} height={40} />
						</Grid>
						<Grid item xs>
							<Typography variant="body1">
								<Skeleton width="60%" />
							</Typography>
							<Typography variant="caption">
								<Skeleton width="40%" />
							</Typography>
						</Grid>
						<Grid item>
							<Skeleton variant="circle" width={34} height={34} />
						</Grid>
					</Grid>
				</Portlet>
			))}
		</>
	)
}

export default ActiveAttendancesSkeleton
